import React, { Component } from "react";
// import Image from "react-bootstrap/Image";
import { SuperAdminTopSearchIcon } from "../../../superAdminReusable/reusableTable/SuperAdminTopTextSearchIcon";
import { ReferralTableUserHeader } from "../ReferralTable/ReferralTableUserHeader";
// import Fillter from "../../../../reusableComponents/allPopupReusable/tableNumberPopup/Filter";
import { ReferralTableUserBody } from "../ReferralTable/ReferralTableUserBody";
// import SuperAdminProfilePopup from "../../../superAdminReusable/reusablePopupSuperAdmin/superadminprofilepopup/SuperAdminProfilePopup";
// import DeletePopup from "../../../../reusableComponents/allPopupReusable/smallPopup/DeletePopup";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../../store/actions/errorActions";
import { superadmin_refrrals_get } from "../../../../../store/actions/SuperAdminActions/superadminreferralsaction";
import { TopNavigationReferralTab } from "../SuperAdminReferralsCode";

import {
  FilterMain,
  SearchWithIconInput,
  SortTopRight,
} from "./ReferralUserComponent";
import SelectFilter from "../../../../reusableComponents/selectFilter";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { FormControl, Select, InputLabel, TextField } from "@material-ui/core";
import { Table, Form, Col, Row } from "react-bootstrap";
import { MenuItem } from "@material-ui/core";
import CSVDownloader from "../../../../reusableComponents/csvDownload/csvDownload";
export class ReferralSalesComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      referrals: [],
      dateQuery: {},
      sort: 2,
      filterValue: "",
      filterValueChecked: "",
      search: "",
    };
  }
  componentDidMount() {
    this.getData(this.dateQuery);
  }

  getData = (date) => {
    const token = this.props.auth.user.accessToken;
    this.props.superadmin_refrrals_get(
      token,
      "Sales",
      date?.startDate,
      date?.endDate
    );
  };

  componentWillReceiveProps(nextProps) {
    if (
      this.state.referrals &&
      this.state.referrals.length !== nextProps.referrals &&
      nextProps.referrals.length
    ) {
      this.setState({ referrals: nextProps.referrals });
    }
  }
  renderTableDataBody = () => {
    const referralsData = this.state.referrals;
    const { sort, filterValueChecked, search } = this.state;
    return (
      <React.Fragment>
        {referralsData
          .sort((a, b) => {
            if (sort === 1) {
              if (new Date(a.createdAt) < new Date(b.createdAt)) return -1;
              if (new Date(a.createdAt) > new Date(b.createdAt)) return 1;
              return 0;
            } else if (sort === 2) {
              if (new Date(a.createdAt) < new Date(b.createdAt)) return 1;
              if (new Date(a.createdAt) > new Date(b.createdAt)) return -1;
              return 0;
            }
          })
          .filter((e) => {
            if (filterValueChecked !== "") {
              return e.referred_id_Model === filterValueChecked;
            } else {
              return true;
            }
          })
          .filter((e) => {
            if (search) {
              return (
                e?.referee_id?.referral_code?.toString()?.includes(search) ||
                e?.referee_id?.first_name?.toString()?.includes(search) ||
                e?.referee_id?.last_name?.toString()?.includes(search)
              );
            }
            return true;
          })
          .map((data, index) => {
            return (
              <ReferralTableUserBody
                key={index}
                id={data._id}
                src={require("../../../../../assets/images/ActionImages/demoprofile.jpg")}
                userName="Kelly McDonald"
                number="+91 8412854369"
                referralCode={data.referee_id && data.referee_id.referral_code}
                used="200"
                refuserId={data.referred_id && data.referred_id._id}
                refree={{
                  src: data.referee_id && data.referee_id.profile_photo[0],
                  name:
                    data.referee_id &&
                    data.referee_id.first_name +
                      " " +
                      data.referee_id.last_name,
                }}
                referred={{
                  src: data.referee_id && data.referee_id.profile_photo[0],
                  name:
                    data.referee_id &&
                    data.referred_id.first_name &&
                    data.referred_id.first_name  +
                      " " +
                      data.referred_id?.last_name &&
                      data.referred_id?.last_name ,
                }}
                refereeRole={data.referee_id_Role && data.referee_id_Role}
                referalRole={data.referred_id_Model && data.referred_id_Model}
                refDate={new Date(data.createdAt && data.createdAt)}
                enrollDate={new Date(data.enroll_date && data.enroll_date)}
              />
            );
          })}
      </React.Fragment>
    );
  };

  onDateChangeHandler = () => (data, type) => {
    this.setState({ dateQuery: data });
    this.getData(data);
  };
  setSort = (sort) => {
    this.setState({ sort: sort });
    this.renderTableDataBody();
  };
  render() {
    const downloadData = {
      headers: [
        { label: "Referrer ID", key: "ReferrerId" },
        { label: "Referral Code", key: "ReferralCode" },
        { label: "Referrer", key: "Referrer" },
        { label: "Referrer Role", key: "role" },
        { label: "Referrerd User ID", key: "referreduserid" },
        { label: "Referred User Name", key: "referredusername" },
        { label: "Referred Role", key: "referredrole" },
        { label: "Referrer Date", key: "Referrerdate" },
        { label: "Enrollment  Date", key: "enrollmentdate" },
      ],
      data: this.state.referrals
        ? this.state.referrals?.map((ele) => {
            return {
              ReferrerId: ele?._id,
              ReferralCode: ele?.referee_id?.referral_code,
              Referrer:
                ele?.referee_id?.first_name + ele?.referee_id?.last_name,
              role: ele?.referred_id_Model,
              referreduserid: ele?.referred_id?._id,
              referredusername:
                ele?.referred_id?.first_name + ele?.referred_id?.last_name,
              referredrole: ele?.referred_id_Model,
              Referrerdate: new Date(ele?.createdAt && ele?.createdAt),
              enrollmentdate: new Date(ele?.enroll_date && ele?.enroll_date),
            };
          })
        : [],
    };
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-3">
            {/* <SuperAdminTopSearchIcon displayIcon={true} /> */}
            <SearchWithIconInput
              onChange={(e) => this.setState({ search: e.target.value })}
              search={this.state.search}
            />
          </div>
          <div className="col-4 p-0"></div>
          <div className="col-3">
            <div className="mr-3">
              <SelectFilter onDateChange={this.onDateChangeHandler()} />
            </div>
          </div>
          <div className="col-2">
            <div className="d-flex align-items-center justify-content-between cursor-pointer">
              <SortTopRight
                setSort={this.setSort}
                filterItems={[
                  { title: "Referred Date & Time", disabled: true },
                  { title: "Old to New", disabled: false },
                  { title: "New to Old", disabled: false },
                  // { title: "User Activity", disabled: true },
                  // { title: `Date & Time 🠑`, disabled: false },
                  // { title: "Date & Time 🠓", disabled: false },
                ]}
              />
              <div
                className="f10-400"
                align="center"
                onClick={() => this.setState({ filter: !this.state.filter })}
              >
                <img
                  src={require("../../../../../assets/images/iconButton/filtericon.png")}
                  width="35px"
                />
                <br />
                Filter
              </div>

              <div className="f10-400" align="center">
                <CSVDownloader
                  filename={"Sales  Representative Referral Report"}
                  headers={downloadData.headers}
                  data={downloadData.data}
                />
              </div>
            </div>
          </div>
        </div>
        <FilterMain
          filterOptions={
            <Row>
              <Col md={6}>
                <Form.Group>
                  <FormControl variant="outlined" className="w-100">
                    <InputLabel htmlFor="outlined-Status">
                      Referred Role
                    </InputLabel>
                    <Select
                      value={this.state.filterValue}
                      onChange={(e) =>
                        this.setState({ filterValue: e.target.value })
                      }
                      label="Referred Rolen"
                      inputProps={{
                        name: "Referred Rolen",
                        id: "outlined-Status",
                      }}
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      {[
                        "User",
                        "Vendor",
                        "Sales",
                        "Affiliates",
                        "Partners",
                      ].map((item, index) => (
                        <MenuItem label={item} value={item} key={index}>
                          {item}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Form.Group>
              </Col>
            </Row>
          }
          show={this.state.filter}
          onCancel={() => this.setState({ filter: false })}
          onFilter={() =>
            this.setState({ filterValueChecked: this.state.filterValue })
          }
        />
        <div className="super-admin-rating-review-tab super-admin-issues-open-users-tab">
          <TopNavigationReferralTab
            selectedTab={this.props.selectedTab}
            pageChanger={this.props.pageChanger}
          />
          {/* <div className="col-3 p-0">
            <SuperAdminTopSearchIcon />
          </div> */}
        </div>
        <div className="col-12 p-0 user-table-reusable-superadmin table-responsive" style={{display:"block",width:"100%",overflowX:"scroll"}}>
          <Table>
            <thead>
              <ReferralTableUserHeader
              headOne={
                <>
                  Referrer
                  <br /> ID
                </>
              }
              headTwo={
                <>
                  Referrer
                  <br /> Code
                </>
              }
              headThree="Referer Name"
              headFour={
                <>
                  Referee
                  <br /> ID
                </>
              }
              headFive="Referee Name"
              headSix={
                <>
                  Referee <br />
                  Role
                </>
              }
              headSeven={
                <>
                  Referred
                  <br /> Date
                </>
              }
              headEight={
                <>
                  Qualifying <br />
                  Activity
                </>
              }
              headNine={
                <>
                  Referral <br />
                  Qualified
                </>
              }
              />
            </thead>
            <tbody>{this.renderTableDataBody()}</tbody>
          </Table>
        </div>
      </React.Fragment>
    );
  }
}

// export default ReferralSalesComponent;

ReferralSalesComponent.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  referrals: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  referrals: state.superAdminReferrals.salersReferrals,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  superadmin_refrrals_get,
})(withRouter(ReferralSalesComponent));
